import { withRouter } from "react-router-dom";
import { ProductPricesComponent } from "./product-prices.component";
import { connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles';
import form from '@style/form'
import modal from '@style/modal'
import combineStyles from '~/utils/styles';

const mapStateToProps = (state, props) => ({});

const actions = {};

export const ProductPricesContainer = connect(mapStateToProps, actions)((withRouter(withStyles(combineStyles(form, modal))(ProductPricesComponent))));
